import React, { useState, useCallback, useMemo } from "react";
import { Button, Paper } from '@material-ui/core';
import { DesktopAccessDisabled } from '@material-ui/icons';
import { useStyles } from '../../css/muiStyle';
import { AlertCompo } from "../../js/components";
import DTable from "../../compo/DTable2";
import SearchBar from "../../compo/searchBar";
import FlagComponent from "../../compo/flagman";

export default function Adm_ses(props){
  const param=props.param
  const Gfunc = require('../../Gfunc')
  const [search,setSearch]=useState('');
  const [doSearch, setDoSearch] = useState(false);
  const [severity, setSeverity] =useState("info");
  const [open, setOpen] =useState(false);
  const [messageA, setMessageA] =useState('');
  const api = '_ses.php'
  const srv="session"
  const classes=useStyles();
  const filter = "&search=" + search;
  const [reset, setReset] = useState(false);
  const [flag, setFlag] = useState(false);


  //handle alerts properties
  const handleAlert=useCallback((open,severity,message)=>{
    setOpen(open)
    setSeverity(severity)
    setMessageA(message)
    setTimeout(function(){
      setOpen(false)
    }, 5000);
  },[])

const columns =useMemo(
    () => [   
      {
          name: "OUVERTURE",
          selector:row=>row.open_date,
          minWidth:'160px !important',
          sortField: "open_date",
          sortable: false,
      },
      {
        name: "UTILISATEUR",
        selector:row=>row.user,
        minWidth:'150px !important',
        sortField: "user",
        sortable: false
      },
      {
          name:'ACTIVITE',
          selector:row=>row.last_action,
          minWidth:'160px !important',
          sortField:"last_action",
          sortable: false
      },
      {
          name:"IP",
          selector:row=>row.ip,
          minWidth:'160px !important',
          sortField:"ip",
          sortable: false
      },
      {
        name:"MACHINE",
        selector:row=>row.host,
        minWidth:'160px !important',
        sortField:"host",
        sortable: false
      },
      {
        right:true,
        cell: (row) => {
          return (
            <FlagComponent
              titleFalse="Fermer session"
              srv={srv}
              row={row}
              att="closed"
              setFlagman={setFlag}
              flagman={flag}
              showAlert={handleAlert}
              //the following props should be sent incase the flag is an icon, cause the flag could be a checkbox
              iconTrue={<></>}
              iconFalse={<DesktopAccessDisabled className={classes.redIcon} fontSize="small" />}
            />      
           );
        }, 
      }  
  ], [flag, classes]);

  function liveSearch(e, search) {
    //this function is used to detect if we are doing a live search or a normal search
    //if param.liveSearch is true and the characters are above 3 then the search would happen each time a character is clicked
    if (param.liveSearch && search.length > 3) {
      e.preventDefault();
      setSearch(e.target.value);
    } else {
      //else it should lunch the search after the enter key is pushed
      if (e.keyCode === 13) handleSearch();
    }
  }

  function handleSearch() {
    const s = document.getElementById("searchBar");
    setSearch(s.value); //each time we set the search value a search request is sent
  }

//kill all session
const handleKillSession=async()=>{
  const response = await Gfunc.axiosGetAction(api, "kall")
    if(response.data.err&&response.data.err!=="-1"){
      handleAlert(true,'error',response.data.err)
    }else{
    Gfunc.axiosResponse(response,()=>{
      handleAlert(true,'success',"Toutes les sessions sont expirées")
      setReset(true)
    })
  }
}

  return (
    <div className="content">
      <AlertCompo severity={severity} open={open} setOpen={setOpen} message={messageA} />
      <Paper className={classes.paperBody} elevation={5}>
        <div className='table-header'>
          <div className='button-flex-wrapper' ><Button className={classes.topTabBtn} variant="contained" color="primary" onClick={handleKillSession} >Fermer toutes les sessions</Button></div>
          <div className='search'>
            {doSearch && (
              <SearchBar liveSearch={liveSearch} handleSearch={handleSearch} />
            )}
            </div>
        </div>
        <div>
          <DTable
            cellHeight={21}
            columns={columns}
            api={api}
            service="get"
            filter={filter}
            setDoSearch={(val) => setDoSearch(val)}
            reset={reset} //Optional
            setReset={setReset} //Optional
            //data={data}//optional in exception cases
            //fetch={fetch}
            fixedHeader={true}
            paginationRowsPerPageOptions={[15, 25, 50, 75, 100]} //optional
          />
        </div>
      </Paper>
    </div>    
  );
}